module.exports = __webpack_public_path__ + "img/var_02_base1_backlight.b4352c36.svg";